export default {
  testning: 'avorp880722!',
  samtestar: 'samtestar',
  strandskolan: 'karlsborg123',
  mölltorpskolan: 'karlsborg123',
  carljohanskolan: 'karlsborg123',
}
